const initFloatingContact = (root = document) => {
  const components = root.matches?.('[data-floating-contact-component]')
    ? [root]
    : root.querySelectorAll('[data-floating-contact-component]');

  components.forEach((component) => {
    if (component.dataset.floatingContactInitialized === 'true') return;

    const dialog = component.querySelector('[data-floating-contact-dialog]');
    const openButton = component.querySelector('[data-floating-contact-open]');
    const closeButton = component.querySelector('[data-floating-contact-close]');

    if (!dialog || !openButton || !closeButton) return;

    component.dataset.floatingContactInitialized = 'true';

    const openDialog = () => {
      if (!dialog.open) dialog.showModal();
    };

    const closeDialog = () => {
      if (dialog.open) dialog.close();
    };

    openButton.addEventListener('click', openDialog);
    closeButton.addEventListener('click', closeDialog);

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });

    dialog.addEventListener('close', () => {
      openButton.focus();

      if (window.location.hash === '#FloatingContactDialog') {
        history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
      }
    });

    if (window.location.hash === '#FloatingContactDialog') openDialog();
  });
};

document.addEventListener('DOMContentLoaded', () => initFloatingContact());

document.addEventListener('shopify:section:load', (event) => {
  initFloatingContact(event.target);
});
